/* ==========================================================
   WM Hero Rewind — wm-hero-rewind.js
   Version: 1.0.0
   ========================================================== */

(function () {
  'use strict';

  var SECTION_TYPE = 'wm-hero-rewind';
  var SELECTOR = '[data-section-type="' + SECTION_TYPE + '"]';

  // The section root is a <div> with data-section-type — NOT a <wm-hero-rewind> element.
  // Do not use customElements.define; find the root by attribute instead. (RULES.md §12.3)

  function init(root) {
    if (root.dataset.wmInit === 'true') return;
    root.dataset.wmInit = 'true';
  }

  function destroy(root) {
    if (root.dataset.wmInit !== 'true') return;
    delete root.dataset.wmInit;
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor — reuse the same init/destroy. Query is scoped to the (re)loaded
  // section, so non-matching sections find nothing and no type check is needed.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll(SELECTOR).forEach(destroy);
  });

})();
